import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { View } from 'react-native';

import NavigationArrow from '../navigation-arrow';

import styles from './touchable-list-item.styles';

class TouchableListItem extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    hideArrow: PropTypes.bool,
    onClick: PropTypes.func,
    arrowAtEnd: PropTypes.bool,
  };

  static defaultProps = {
    onClick: () => {},
    hideArrow: false,
    arrowAtEnd: false,
  };

  render() {
    const { children, onClick, hideArrow } = this.props;
    var arrowStyle = (this.props.arrowAtEnd ? styles.absoluteArrow : styles.arrow);
    return (
      <div onClick={onClick} className="pointer">
       <View  style={styles.root}>
        <View style={styles.content}>{children}</View>
        <View style={styles.arrowWrapper}>
          {!this.props.hideArrow ? <View style={arrowStyle}><NavigationArrow size="large" /></View>: null }
        </View>
        </View>
      </div>
    );
  }
}

export default TouchableListItem;
